import Button from '@rio-cloud/rio-uikit/Button';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import type { MessageKey } from '../../../../configuration';

interface Props {
    disabled?: boolean;
    isInProgress?: boolean;
    confirmMessageId: MessageKey;
    loadingMessageId: MessageKey;
    onClick: (event: React.MouseEvent) => void;
}

export const StripeCreatePaymentButton = (props: Props) => {
    const { disabled = false, isInProgress = false, confirmMessageId, loadingMessageId, onClick } = props;

    if (isInProgress) {
        return (
            <Button
                type='button'
                className='StripeCreatePaymentButton-loading btn btn-primary disabled'
                key={'loading'}
                autoTrackingKey={loadingMessageId}
            >
                <FormattedMessage id={loadingMessageId} />
            </Button>
        );
    }

    return (
        <Button
            type='button'
            className={classnames('StripeCreatePaymentButton', 'btn btn-primary', disabled && 'disabled')}
            onClick={onClick}
            key={'clickable'}
            autoTrackingKey={confirmMessageId}
        >
            <FormattedMessage id={confirmMessageId} />
        </Button>
    );
};
